/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import DataTable from 'react-data-table-component';
import {
  // Form,
  Input,
  Button,
  Radio,
  DatePicker,
  notification
} from "antd";
import butSearch from "../../../assets/icons/icon-but-search.png";
import Cookies from "js-cookie";
import "./custom-antd.css";
import moment from "moment";
import Api from "../../../services/ServiceApi";
import { connect } from "react-redux";
import { changeLang } from "../../../actions/langAction";
import { setDynamic } from "../../../actions/dynamicAction";
import 'moment/locale/th';
// import locale from 'antd/lib/locale/th_TH';

class Plant extends Component {
/** JSON.parse(localStorage.getItem("companyData") */
  constructor(props) {
    super(props);
    this.state = {
      
      factUpdate: false,
      LangTranslate: [[]],
      title: "Plant",
      companyDataList: JSON.parse(localStorage.getItem("companyData")),
      companyID: "",
      companyIDAdd: "",
      workCenterIDAdd: "",
      workCenterDataAdd: [],
      plantIDADD: 0,
      plantNameAdd: "",
      AddPlantDisplay: "none",
      ConfirmDisplay: "none",
      dateFormat: "DD/MM/YYYY",
      EffectiveDateAdd: moment().toDate(),
      EffectiveDateAddFilter: moment().toDate(),
      ExpiryDateAdd: moment().toDate(),
      statusAdd: 1,
      active: ["Inactive","Active"],
      where: "",
      filterDataList: [],
      fillEffectiveDateDisplay: "none",
      resultAddNewFail: false,
      resultAddNewText: "",
      actionPlant: "Add",
      actionPlantButton: "Add",
      disableChangeValue: false,
      str_company_permission: ""
    };

    this.state.companyDataList.map((item, index) => (
      (this.state.str_company_permission == "")? this.state.str_company_permission = item.company_id :
      this.state.str_company_permission = this.state.str_company_permission + ","+ item.company_id
    ))

    this.state.companyID = this.state.str_company_permission;
  }

  async componentDidMount() {
   
    console.log("company name",this.state.companyDataList);
    
    Api.post("master_language_detail_get", {
      company_id: Cookies.get("companyid"),
      page_id: 1,
    })
      .then((response) => {
        this.setState({
          LangTranslate: JSON.parse(
            response.data.data["masteR_LANGUAGE_DETAIL"][0].file_json
          ),
          factUpdate: true,
        });
      })
      .catch((e) => {
        console.log(e);
      });
      this.loadSLOCPlant();
      this.loadWorkCenter(Cookies.get("companyid"));

  }

  notify = (type, title, msg) => {
    const args = {
      message: title,
      description: msg,
      duration: 5,
      className: "font-thai-b",
    };
    notification[type](args);
  };

  loadSLOCPlant = () => {
    this.setState({filterDataList:[]});
    Api.post("master_data/get_plant", {
      company_id: this.state.companyID,
      where: this.state.where,
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.code === "P") {
          const tmp = [];
          data.result.map((item, index) => (
            tmp.push({
              "companyName": item.company_name,
              "workCenterName": <div title={item.work_center_name}>{item.work_center_name}</div>,
              "plantName": <div title={item.plant_name}>{item.plant_name}</div>,
              "status": <div className={"problem-type-"+this.state.active[item.is_active]}>{this.state.active[item.is_active]}</div>,
              "effectiveDate": this.displayDate(item.effective_date),
              "expiredDate": this.displayDate(item.expire_date),
              "Option":<button onClick={()=> this.clickEdit(item.plant_id,item.company_id,item.work_center_id,item.plant_name,item.is_active,item.effective_date,item.expire_date)} id={"btnEdit"+index} className="text-primary">edit</button>
            })
          ))
          this.setState({ filterDataList: tmp});
        }
      })
      .catch((e) => {
        console.log("error loading get_plant", e);
      });
  }

  clickEdit = (plant_id,company_id, work_center_id, plant_name, is_active, effective_date, expire_date) => {
    this.loadWorkCenter(company_id);
    console.log('plant id = '+plant_id);
    this.setState({
      plantIDADD: plant_id,
      companyIDAdd: company_id,
      workCenterIDAdd: work_center_id,
      plantNameAdd: plant_name,
      statusAdd: is_active,
      EffectiveDateAdd: (effective_date != null)? this.displayDate(effective_date): "",
      EffectiveDateAddFilter: (effective_date != null)? effective_date: "",
      ExpiryDateAdd: (expire_date != null)? this.displayDate(expire_date) : "",
      actionPlant: "Edit",
      actionPlantButton: "Save"

    })
    this.onAddPlant();
  };

  loadWorkCenter = (company_id) =>{
    this.setState({workCenterDataAdd:[]});
    /* get workcenter */
    Api.post("master_data/work_center_single", {
      company_id: company_id,
      is_active: 1,
      where: "",
    })
      .then((res) => {
        this.setState({workCenterDataAdd:res.data.data.result});
      })
      .catch((e) => {
        console.log(e);
      });
  }
  setWorkCenterAdd = (event) => {
    this.setState({workCenterIDAdd:event.target.value})
  }
  
  setStatus = (event) => {
    this.setState({
      statusAdd: event.target.value
    })
  }

  setSearchText = (event) => {
    this.setState({
      where: event.target.value
    })
  }

  onChangeEffectiveDate = (dateString) =>{
    this.setState({
      EffectiveDateAdd: dateString,
      EffectiveDateAddFilter: dateString
    })
  }

  onChangeExpiryDate = (dateString) => {
    this.setState({
      ExpiryDateAdd: dateString
    })
  }

  onAddPlant = () => {
    window.scrollTo(0, 0);
    if(this.state.AddPlantDisplay == "none"){
      this.setState({
        AddPlantDisplay: "block"
      })
    }else{
      this.setState({
        AddPlantDisplay: "none"
      })
    }
  }

onCallConfirmWindow = () => {
  if(this.state.ConfirmDisplay == "none"){
    this.setState({ConfirmDisplay: "block"});
  }else{
    this.setState({ConfirmDisplay: "none", resultAddNewFail: false})
  }
}

onResetFormAddNew = () => {
  this.onCallConfirmWindow();
  this.onCloseAddNewWindow();
  this.onAddPlant();
}

onCloseAddNewWindow = () => {
  this.setState({
    companyIDAdd: "",
    workCenterDataAdd: [],
    workCenterIDAdd: "",
    plantNameAdd: "",
    statusAdd: 1,
    EffectiveDateAdd: moment().toDate(),
    EffectiveDateAddFilter: moment().toDate(),
    ExpiryDateAdd: moment().toDate(),
    AddPlantDisplay: "none",
    actionPlant: "Add",
    actionPlantButton: "Add",
    disableChangeValue: false
  })
}

displayDate  = (data) => {
  if(data != null){
    const day = data.substring(0,10).split("-");
    return day[2] + "/" + day[1] + "/" + day[0];
  }
  return "-";
}
onCallConfirmWindowAndCallAddNewAgain = () => {
  this.onCallConfirmWindow();
  this.onAddPlant();
}

ClickAction = (e) => {
  window.scrollTo(0, 0);
  e.preventDefault();

  // check validate value
  if(this.state.plantNameAdd.length != 4){
    this.notify("info", "Informaton", "Please key plant name 4 digital charactor only.");
    e.stopPropagation();
  } else{
    if(this.state.EffectiveDateAdd == ""){
      this.setState({fillEffectiveDateDisplay:"block"});
    }else{
      this.setState({fillEffectiveDateDisplay:"none"});
      // statement save data 
      (this.state.actionPlant == "Add") ? 
      
        Api.post("master_data/insert_plant", {
        company_id: this.state.companyIDAdd,
        work_center_id: this.state.workCenterIDAdd,
        plant_name: this.state.plantNameAdd,
        is_active: this.state.statusAdd,
        create_by: Cookies.get("userId"),
        effective_date: moment(this.state.EffectiveDateAdd,"DD/MM/YYYY").format("YYYY-MM-DD"),
        expire_date: (this.state.ExpiryDateAdd) != ''? moment(this.state.ExpiryDateAdd,"DD/MM/YYYY").format("YYYY-MM-DD"):null,
        TokenUser : Cookies.get(`OperationToken`)
        })
        .then((res) => {
          console.log('Action: Add');
          const { result, data } = res.data;
          if (result.code === "P") {
            this.setState({resultAddNewFail: false})
            
            this.onCloseAddNewWindow();
          }else{
            this.setState({AddPlantDisplay : "none",resultAddNewFail: true})
          }
          if(result.showText == "Success"){
            this.setState({resultAddNewText:"เพิ่มข้อมูลเสร็จสิ้น"});
          }else{
            this.setState({resultAddNewText:result.showText});
          }
          //confirm
          this.onCallConfirmWindow();

        })
        .catch((e) => {
          console.log("error add new plant", e);
        })
      : this.editData(e)// statement save data
      
    }
  }
  e.stopPropagation();
}

editData = (e) => {
  console.log('Action: Edit');
  window.scrollTo(0, 0);
  e.preventDefault();
  if(this.state.EffectiveDateAdd == ""){
    this.setState({fillEffectiveDateDisplay:"block"});
  }else{
    this.setState({fillEffectiveDateDisplay:"none"});
    /** statement save data */
    Api.post("master_data/update_plant", {
      plant_id : this.state.plantIDADD,
      company_id: this.state.companyIDAdd,
      work_center_id: this.state.workCenterIDAdd,
      plant_name: this.state.plantNameAdd,      
      is_active: this.state.statusAdd,
      update_by: Cookies.get("userId"),
      effective_date: moment(this.state.EffectiveDateAdd,"DD/MM/YYYY").format("YYYY-MM-DD"),
      expire_date: (this.state.ExpiryDateAdd) != ''? moment(this.state.ExpiryDateAdd,"DD/MM/YYYY").format("YYYY-MM-DD"):null,
      TokenUser : Cookies.get(`OperationToken`)
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.code === "P") {
          this.setState({resultAddNewFail: false})
          this.onCloseAddNewWindow();
        }else{
          this.setState({AddPlantDisplay : "none",resultAddNewFail: true})
        }
        if(result.showText == "Success"){
          this.setState({resultAddNewText:"แก้ไขข้อมูลเสร็จสิ้น"});
        }else{
          this.setState({resultAddNewText:result.showText});
        }
        /** confirm */
        this.onCallConfirmWindow();
        //this.loadSLOCPlant();

      })
      .catch((e) => {
        console.log("error editing plant", e);
      })
  }
}
/*8888888888888888888888888888*/
setCompany = (event) => {
  this.setState({
    companyID: event.target.value
  })
}

setCompanyAdd = (event) => {
  this.setState({
    companyIDAdd: event.target.value,
    workCenterIDAdd: ""
  })
  if(event.target.value == null){
    this.setState({workCenterDataAdd:[]})
  }else{
    this.loadWorkCenter(event.target.value);
  }
}

setWorkCenterAdd = (event) => {
  this.setState({
    workCenterIDAdd: event.target.value
  })
}

setPlantNameAdd = (event) => {
  this.setState({
    plantNameAdd: event.target.value
  })
}

onSearch = () => {
  this.loadSLOCPlant();
}

render() {
  //console.log('company:'+this.state.companyDataList.auth);
  //console.log('company list:'+this.state.companyDataList["companyData"]);
  //console.log('Language:'+this.state.LangTranslate);
  const locale = Cookies.get("locale");
  const columns =  [
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["CompanyName"] : `Company Name`,
      selector: 'companyName',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["WorkCN"] : 'Work Center Name',
      selector: 'workCenterName',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["plantName"] : 'Plant Name',
      selector: 'plantName',
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["status"] : 'Status',
      selector: 'status',
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["EffectiveDate"] : 'Effective Date',
      selector: 'effectiveDate',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["ExpiredDate"] : 'Expired Date',
      selector: 'expiredDate',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["Action"] :'Action',
      selector: 'Option',
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      style: 'cursor:pointer'
    },
  ];

        return (
            <div>
                <span className="font-mont-r fs-12">Basic Data</span>
                <h3 className="font-mont-sb fs-18 c-blue">{this.state.title}</h3>
                <div className="w-100 box-search m-0">
                  <div className="row">
                      <div style={{verticalAlign:"text-top"}}>
                        <div className="box-search m-0 d-flex">
                          <div>
                          <select 
                            id="Company"
                            placeholder="Please select Company"
                            className="dropdrowtype input-text-add-problem-type form-select"
                            onChange={(e) => this.setCompany(e)}
                            value={this.state.companyID}                            
                          >
                            <option value="" className="please-select">PLEASE SELECT COMPANY</option>
                            {
                            this.state.companyDataList.map((item, index) => (
                              <option value={item.company_id} key={`layout_b_${index}`}>
                              {item.company_name}
                              </option>
                            ))}
                            </select>
                          </div>
                          <div className="pl-3">
                          <Input
                            onChange={(e)=>this.setSearchText(e)}
                            placeholder="Search Plant Name"
                            style={{ width: 200 }}
                            value={this.state.where}
                            
                          /><img type="button" src={butSearch} onClick={()=>this.onSearch()} className="but-search"/></div>                          
                        </div>
                      </div>
                  
                      <div className="box-but-add-SLOC">
                        <button className="but-add-problem-type" onClick={()=>this.onAddPlant()}>Add {this.state.title}</button>
                      </div>
                  </div>
                </div>
                
                <div className="box-content">
                    {/** load data */}
                    <DataTable 
                      style={{fontSize:"20px"}}
                      columns={columns}
                      data={this.state.filterDataList}
                      pagination
                      highlightOnHover
                    />
                </div>
              
                <div id="AddPlantWindow" className="add-new-window" style={{
                          position: 'absolute', top: '20%',
                          left: '50%',
                          marginLeft: '-260px',
                          display: this.state.AddPlantDisplay
                      }}>
                  <form className="needs-validation" onSubmit={(e)=>this.ClickAction(e)}>
                  <div>
                    <div className="header-add-problem-type-window">{this.state.actionPlant} {this.state.title}</div>
                    {/* row1 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["CompanyName"] : `Company Name`}</div>
                        <div>
                            <select 
                            id="CompanyAdd"
                            placeholder="Please select Company"
                            className="dropdrowtype input-text-add-problem-type form-select"
                            onChange={(e)=>this.setCompanyAdd(e)}
                            value={this.state.companyIDAdd}
                            disabled={(this.state.disableChangeValue)? "disabled":false}
                            required
                          >
                            <option value="" className="please-select">PLEASE SELECT COMPANY</option>
                            {
                            this.state.companyDataList.map((item, index) => (
                              <option value={item.company_id} key={`layout_b_${index}`}>
                              {item.company_name}
                              </option>
                            ))}
                            </select>
                        </div>
                      </div>
                      <div className="col-sm-6 m-0 p-0 pl-3">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["WorkCN"] : `Work Center Name`}</div>
                        <div>
                            <select
                                  id="WorkCenterAdd"
                                  placeholder="Please select Work Center"
                                  className="dropdrowtype input-text-add-problem-type form-select"
                                  onChange={(e)=>this.setWorkCenterAdd(e)}
                                  value={this.state.workCenterIDAdd}
                                  required
                                >
                                <option value="" className="please-select">PLEASE SELECT WORK CENTER</option>
                                {this.state.workCenterDataAdd.map((item, index) => (
                                  <option value={item.work_center_id} key={`layout_b_${index}`}>
                                    {item.work_center_name}
                                  </option>
                                ))}
                              </select>
                        </div>
                      </div>
                    </div>

                    {/* row2 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                      <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["plantName"] : `Plant Name`}</div>
                        <div>
                          <input maxLength="4" onChange={(e)=>this.setPlantNameAdd(e)} value={this.state.plantNameAdd} className="input-text-add-problem-type" required></input>
                        </div>
                      </div>
                      <div className="col-sm-6 m-0 p-0 pl-3"></div>                      
                    </div>
                    {/* row3 */}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["status"] : `Status`}</div>
                      </div>
                      <div className="col-sm-12 p-0">
                      <Radio.Group 
                        id="statusAdd"
                        name="statusAdd" 
                        defaultValue={this.state.statusAdd}
                        onChange={(e)=>this.setStatus(e)}
                      >
                        <Radio value={1}>Active</Radio>
                        <Radio value={0}>Inactive</Radio>
                      </Radio.Group>
                      </div>
                    </div>
                    {/* row5 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["EffectiveDate"] : 'Effective Date'}</div>
                        <div><DatePicker style={{padding: 8}} onChange={(dateString)=>this.onChangeEffectiveDate(dateString)} value={(this.state.EffectiveDateAdd != '')? moment(this.state.EffectiveDateAdd, this.state.dateFormat):""} format={this.state.dateFormat} />
                        <div style={{display: this.state.fillEffectiveDateDisplay, position: "absolute",color:"#FF0000"}}>Please fill effective date</div>
                        </div>
                      </div>
                      <div className="col-sm-6 m-0 p-0 pl-3">
                        <div className="title-add">{(this.state.factUpdate)? this.state.LangTranslate[locale]["ExpiredDate"] : 'Expired Date'}</div>
                        <div><DatePicker style={{padding: 8}} onChange={(dateString) => this.onChangeExpiryDate(dateString)}  value={(this.state.ExpiryDateAdd != '')? moment(this.state.ExpiryDateAdd, this.state.dateFormat):""} format={this.state.dateFormat} disabledDate={d => !d || d.isAfter(moment().add(100,"years")) || d.isSameOrBefore(this.state.EffectiveDateAddFilter)} /></div>
                      </div>
                    </div>
                    {/* row5 */}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0 pt-3 text-center">
                        <Button onClick={()=>this.onCloseAddNewWindow()}>&nbsp;&nbsp;Cancel&nbsp;&nbsp;</Button>&nbsp;<button type="submit"  className="btn btn-primary-active" >&nbsp;&nbsp;&nbsp;{this.state.actionPlantButton}&nbsp;&nbsp;&nbsp;</button>
                      </div>
                    </div>

                  </div>
                </form>
                </div>

                <div id="ConfirmWindow" className="confirm-window" style={{
                          position: 'absolute', left: '50%', top: '20%',
                          transform: 'translate(-50%, -20%)',
                          display: this.state.ConfirmDisplay
                      }}>
                  <div className="row">
                    <div className="col-sm-12 m-0 p-3 text-center txt-confirm">
                      {this.state.resultAddNewText}
                    </div>
                  </div>
                  <div className="row row-add">
                    <div className="col-sm-12 m-0 p-0 text-center">
                      {
                        (this.state.actionPlant == "Add")?
                          ((this.state.resultAddNewFail == true)? <Button type="primary" onClick={()=>this.onCallConfirmWindowAndCallAddNewAgain()}>&nbsp;&nbsp;{(this.state.factUpdate)? this.state.LangTranslate[locale]["butClose"] : `Close`}&nbsp;&nbsp;</Button> : <Button onClick={this.onResetFormAddNew}>&nbsp;&nbsp;&nbsp;เพิ่มอีกครั้ง&nbsp;&nbsp;&nbsp;</Button>):null
                      }&nbsp;&nbsp;
                      {
                        (this.state.resultAddNewFail == false)? <Button type="primary" onClick={()=>this.onCallConfirmWindow()}>&nbsp;&nbsp;ปิด&nbsp;&nbsp;</Button>:null
                      }
                    </div>
                  </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => ({
  lang: state.lang,
  dynamicReducer: state.dynamicReducer,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
    setDynamic: (data, visible) => dispatch(setDynamic(data, visible)),
  };
};
export default connect(mapStateToProps, mapDispacthToProps)(Plant);

